import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  TableContainer,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Paper,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { notification } from "antd";
import { styled } from "@mui/system";
import { COLORS } from "../config/theme";
import Switch from "@mui/material/Switch";
import Modal from "./Modal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AddIcon from "@mui/icons-material/Add";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { Modal as ModalAntd } from "antd";
import AgregarRequisitoManual from "./AgregarRequisitoManual";
import moment from "moment";
import RequisitoRespuestaTexto from "./RequisitoRespuestaTexto";
import RequisitoRespuestaSiNoNoSabe from "./RequisitoRespuestaSiNoNoSabe";
import VerificarRequisito from "./VerificarRequisito";
import RequisitoRespuestaArchivo from "./RequisitoRespuestaArchivo";
import { obtenerDocumento } from "../services/uploadFile.service";
import RequisitoListaHistorico from "./RequisitoListaHistorico";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {
  eliminarRequisitoDeExpediente,
  cambiarOpcionalidadDeRequisito,
} from "../services/expediente.service";
import { getOficinasDeUsuario } from "../services/usuarios.service";
import VerFormularios from "./VerFormularios";

import "./RequisitosTable.css";
import AgregarRequisitoExpediente from "./AgregarRequisitoExpediente";
import { evaluaPermisoPorOficinasDeUsuario } from "../services/oficinas.service";

export const RequisitosTable = ({
  data,
  setReload,
  reload,
  oficinasList,
  id_expediente,
  usuario,
  accionAgregar = false,
  accionCompletar = false,
  accionAgregarPlantilla = false,
  accionEliminar = false,
  accionVerificar = false,
  accionHistorial = false,
  accionProcedimiento = true,
  accesoOpcionalRequisito = false,
  disabled = false,
}) => {
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [modalWidth, setModalWidth] = useState("500px");
  const [oficinasUsuario, setOficinasUsuario] = useState([]);
   const { confirm } = ModalAntd;

  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    height: "220px", // Establece una altura fija para el contenedor
    overflowY: "auto", // Habilita el scroll vertical si el contenido supera la altura
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows
      ? theme.shadows[3]
      : "0 3px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: theme.shape ? theme.shape.borderRadius : "4px",
  }));

  const StyledTableHead = styled(TableHead)(({ theme }) => ({
    backgroundColor: theme?.palette?.primary?.main || COLORS.SECONDARY,
    "& .MuiTableCell-head": {
      color: theme?.palette?.common?.white || "#fff",
      fontWeight: "bold",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme, index }) => ({
    backgroundColor:
      index % 2 === 0 ? theme?.palette?.action?.hover || "#f5f5f5" : "white",
  }));

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
  };

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "5px",
  };

  const cellHeaderStyle = {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "Center",
  };

  const abrirDocumento = async (key) => {
    console.log("llamamos a abrir doucmento");
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  const obtenerBackGroundColorPorEstado = (estado) => {
    switch (estado) {
      case 0:
        return COLORS.AMARILLO_PENDIENTE;
      case 1:
        return COLORS.CELESTE_CLARO; // Celeste cuando esta pendiente de verificación
      case 2:
        return COLORS.VERDE_CLARO; // Verde claro si está aprobado// Rojo claro si está rechazado
      case 3:
        return COLORS.ROJO_CLARO; // Rojo claro si está rechazado
      case 4:
        return COLORS.VIOLETA; // Rojo claro si está rechazado
      default:
        return COLORS.BLANCO; // Blanco por defecto
    }
  };

  const obtenerColorPorEstado = (estado) => {
    switch (estado) {
      case 0:
        return "font_black";
      default:
        return "font_white"; // Blanco por defecto
    }
  };

  const mostrarHistorialRequisito = (id, row) => {
    console.log("row selected: ", row);
    setModalTitle(
      <>
        HISTORIAL: <strong>{row.requisito_nombre.toUpperCase()}</strong>
      </>
    );
    setModalWidth("1200px");
    setModalContent(
      <RequisitoListaHistorico
        setIsVisibleModal={setIsVisibleModal}
        setReload={setReload}
        reload={reload}
        requisito={row}
      />
    );
    setIsVisibleModal(true);
  };

  const mostrarCompletarRequisito = (id, row) => {
    console.log("row selected: ", row);
    setModalWidth("500px");
    switch (row.id_tipo_resultado) {
      case 1:
        setModalTitle(
          <>
            AGREGAR DOCUMENTO REQUERIDO:{" "}
            <strong>{row.requisito_nombre.toUpperCase()}</strong>
          </>
        );
        break;
      case 2:
        setModalTitle(
          <>
            AGREGAR OBSERVACIÓN REQUERIDA:{" "}
            <strong>{row.requisito_nombre.toUpperCase()}</strong>
          </>
        );
        break;
      case 3:
        setModalTitle(
          <>
            SELECCIÓN DE OPCIONES:{" "}
            <strong>{row.requisito_nombre.toUpperCase()}</strong>
          </>
        );
        break;

      case 4:
        setModalTitle(
          <>
            SELECCIÓN DE OPCIONES:{" "}
            <strong>{row.requisito_nombre.toUpperCase()}</strong>
          </>
        );
        break;
      default:
        break;
    }

    setModalContent(
      <>
        {(row.mov_respuesta_file_id || row.mov_respuesta_obs) && (
          <Grid
            item
            xs={12}
            style={{
              marginBottom: 20,
              border: "2px solid green", // Borde de 2px de color rojo
              borderRadius: "8px", // Bordes ligeramente redondeados
              padding: "10px", // Opcional: añadir padding para que el contenido no esté pegado al borde
            }}
          >
            {row.mov_respuesta_obs && (
              <Typography variant="body1">
                RESPUESTA: {row.mov_respuesta_obs}
              </Typography>
            )}
            {row.mov_respuesta_file_id && (
              <div
                onClick={() => abrirDocumento(row.respuesta_file_url)}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                <DescriptionOutlinedIcon style={{ fontSize: 40 }} />
                <Typography variant="body2">
                  {row.respuesta_file_nombre}
                </Typography>
              </div>
            )}
          </Grid>
        )}
        {(row.revision_file_url || row.mov_revision_obs) && (
          <Grid
            item
            xs={12}
            style={{
              marginBottom: 20,
              border: "2px solid red", // Borde de 2px de color rojo
              borderRadius: "8px", // Bordes ligeramente redondeados
              padding: "10px", // Opcional: añadir padding para que el contenido no esté pegado al borde
            }}
          >
            {row.mov_revision_obs && (
              <Typography variant="body1" style={{ color: COLORS.DANGER }}>
                MOTIVO DE RECHAZO:
                <br /> <b>{row.mov_revision_obs}</b>
              </Typography>
            )}
            {row.revision_file_url && (
              <div
                onClick={() => abrirDocumento(row.revision_file_url)}
                style={{
                  textDecoration: "none",
                  color: COLORS.DANGER,
                  cursor: "pointer",
                }}
              >
                <DescriptionOutlinedIcon
                  style={{ fontSize: 40, cursor: "pointer" }}
                />
                <Typography variant="body2">VER DOCUMENTO</Typography>
              </div>
            )}
          </Grid>
        )}
        {row.id_tipo_resultado === 1 && (
          <RequisitoRespuestaArchivo
            setIsVisibleModal={setIsVisibleModal}
            setReload={setReload}
            reload={reload}
            id_expediente={id_expediente}
            requisito={row}
          />
        )}
        {row.id_tipo_resultado === 2 && (
          <RequisitoRespuestaTexto
            setIsVisibleModal={setIsVisibleModal}
            setReload={setReload}
            reload={reload}
            requisito={row}
          />
        )}
        {row.id_tipo_resultado === 3 && (
          <RequisitoRespuestaSiNoNoSabe
            setIsVisibleModal={setIsVisibleModal}
            setReload={setReload}
            reload={reload}
            id_expediente={id_expediente}
            requisito={row}
          />
        )}
        {row.id_tipo_resultado === 4 && (
          <RequisitoRespuestaSiNoNoSabe
            showNoSabe={true}
            setIsVisibleModal={setIsVisibleModal}
            setReload={setReload}
            reload={reload}
            id_expediente={id_expediente}
            requisito={row}
          />
        )}
      </>
    );
    setIsVisibleModal(true);
  };

  const mostrarAgregarPlantilla = (idMov, row) => {
    setModalTitle(
      <>
        AGREGAR PLANTILLA PARA:{" "}
        <strong>{row.requisito_nombre.toUpperCase()}</strong>
      </>
    );
    setModalWidth("900px");
    setModalContent(
      <AgregarRequisitoExpediente
        idMov={idMov}
        row={row}
        setReload={setReload}
        reload={reload}
        id_expediente={id_expediente}
        setIsVisibleModal={setIsVisibleModal}
      />
    );
    setIsVisibleModal(true);
  };

  const verificarRequisito = async (id, row) => {
    const puedeValidar = await verificarPermisoValidacion(row);
    if (!puedeValidar) {
      console.log("No puede validar requisito");
      notification["error"]({
        message:
          "No podes visar requisitos de oficinas a las que no pertenezcas",
      });
      return false;
    }
    console.log("row selected: ", row);
    setModalTitle(
      <>
        ¿Aprueba el requerimiento{" "}
        <strong>{row.requisito_nombre.toUpperCase()}</strong>?
      </>
    );
    setModalWidth("600px");
    setModalContent(
      <>
        <VerificarRequisito
          setIsVisibleModal={setIsVisibleModal}
          setReload={setReload}
          reload={reload}
          id_expediente={id}
          requisito={row}
        />
      </>
    );
    setIsVisibleModal(true);
  };

  const verificarPermisoValidacion = async (row) => {
    // Si el estado de oficinasUsuario está vacío, realiza la llamada para obtener las oficinas
    if (oficinasUsuario.length === 0) {
      try {
        const oficinas = await getOficinasDeUsuario(usuario.id_usuario); // Realiza la llamada para obtener las oficinas
        setOficinasUsuario(oficinas.data); // Actualiza el estado con las oficinas obtenidas
  
        const oficinasRequisito = row.oficina_ids.split(","); // Convertir el string en array si es necesario
        const existeOficina = oficinas.data.some(
          (oficinaUsuario) => oficinasRequisito.includes(oficinaUsuario.toString()) // Verificar si alguna oficina del usuario está en el array de oficinas del requisito
        );
  
        return existeOficina; // Retorna el resultado de la validación
      } catch (error) {
        console.error("Error fetching oficinas:", error);
        return false; // Retorna false si hubo un error al obtener las oficinas
      }
    } else {
      const oficinasRequisito = row.oficina_ids.split(","); // Convertir el string en array si es necesario
      const existeOficina = oficinasUsuario.some(
        (oficinaUsuario) => oficinasRequisito.includes(oficinaUsuario.toString()) // Verificar si alguna oficina del usuario está en el array de oficinas del requisito
      );
      return existeOficina;
    }
  }

  const mostrarProcedimientoRequisito = (id, row) => {
    console.log("row selected: ", row);
    setModalTitle(
      <>
        PROCEDIMIENTO: <strong>{row.requisito_nombre.toUpperCase()}</strong>
      </>
    );
    setModalWidth("600px");
    setModalContent(
      <>
        <div
          style={{ fontSize: 16, color: COLORS.DARK_GREY, textAlign: "left" }}
        >
          {accionCompletar && (
            <>
              <b>¿Como completar el requisito?</b>
              <p>{row.procedimiento}</p>
            </>
          )}
          {accionVerificar && (
            <>
              <b>¿Cómo valido el requisito?</b>
              <p>{row.validacion}</p>
            </>
          )}
        </div>
      </>
    );
    setIsVisibleModal(true);
  };

  const obtenerAccion = (row) => {
    if (disabled) return <></>;
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          cursor: "pointer",
          fontSize: 16,
        }}
      >
        {accionCompletar && (
          <Tooltip title="Completar requisito">
            <div onClick={() => mostrarCompletarRequisito(row.id_mov, row)}>
              <AssignmentTurnedInOutlinedIcon />
            </div>
          </Tooltip>
        )}
        {accionAgregarPlantilla && (
          <Tooltip title="Agregar plantilla">
            <div onClick={() => mostrarAgregarPlantilla(row.id_mov, row)}>
              <PostAddIcon />
            </div>
          </Tooltip>
        )}
        {accionVerificar && (
          <Tooltip title="Verificar requisito">
            <div onClick={() => verificarRequisito(row.id_mov, row)}>
              <DoneOutlinedIcon />
            </div>
          </Tooltip>
        )}
        {accionHistorial && (
          <Tooltip title="Ver historial del requisito">
            <div onClick={() => mostrarHistorialRequisito(row.id_mov, row)}>
              <HistoryOutlinedIcon />
            </div>
          </Tooltip>
        )}
        {accionEliminar && (
          <Tooltip title="Eliminar requisito">
            <div onClick={() => mostrarEliminarRequisito(row.id_mov, row)}>
              <DeleteOutlineIcon />
            </div>
          </Tooltip>
        )}
        {accionProcedimiento && (
          <Tooltip title="Ver procedimiento del requisito">
            <div onClick={() => mostrarProcedimientoRequisito(row.id_mov, row)}>
              <HelpOutlineOutlinedIcon />
            </div>
          </Tooltip>
        )}
      </div>
    );
  };

  const mostrarEliminarRequisito = (id_mov, row) => {
    try {
      confirm({
        title: "Eliminar requisito",
        content: `¿Esta seguro que desea eliminar el requisito?`,
        okText: "Eliminar",
        okType: "danger",
        cancelText: "Salir",
        async onOk() {
          eliminarRequisito(id_mov, row);
        },
      });
    } catch (error) {
      console.log("error catch delete requset", error);
    }
  };

  const eliminarRequisito = async (id_mov, row) => {
    await eliminarRequisitoDeExpediente(id_mov);
    setReload(!reload);
  };

  const getEstadoNombre = (id_estado) => {
    switch (id_estado) {
      case 0:
        return "Pendiente"; // Verde claro si está aprobado
      case 1:
        return "En revisión"; // Rojo claro si está rechazado
      case 2:
        return "Aprobado"; // Rojo claro si está rechazado
      case 3:
        return "Rechazado"; // Rojo claro si está rechazado
      case 4:
        return "Revisión en curso"; // Rojo claro si está rechazado
      default:
        return ""; // Blanco por defecto
    }
  };

  const obtenerFormularios = (row) => {
    setIsVisibleModal(true);
    setModalTitle("FORMULARIOS");
    setModalWidth("600px");
    setModalContent(
      <>
        <div
          style={{
            fontSize: 16,
            color: COLORS.DARK_GREY,
            textAlign: "left",
            marginBottom: 15,
          }}
        >
          {row.procedimiento}
        </div>
        <VerFormularios
          setIsVisibleModal={setIsVisibleModal}
          setReload={setReload}
          reload={reload}
          requisito={row}
        />
      </>
    );
  };

  const agregarRequisito = () => {
    setIsVisibleModal(true);
    setModalTitle("Nuevo requisito");
    setModalWidth("600px");
    setModalContent(
      <AgregarRequisitoManual
        setReload={setReload}
        reload={reload}
        setIsVisibleModal={setIsVisibleModal}
        oficinasList={oficinasList}
        id_expediente={id_expediente}
      />
    );
  };

  const setOpcionalidadDeRequisito = (id_mov, value) => {
    cambiarOpcionalidadDeRequisito(id_mov, value).then(() => {
      setReload(!reload);
    });
    // Lógica para cambiar la opcionalidad (puede ser una llamada a una API)
  };

  const getTooltipPorEstado = (
    id_estado,
    oficinasRelacionadas,
    oficinasVisadas
  ) => {
    // if (id_estado !== 4) return null; // Solo mostrar tooltip si el estado es 4 (VISADO EN PROCESO)

    // Crear un mapeo con "SI" o "NO" para cada oficina relacionada
    return oficinasRelacionadas
      .map((oficina) => {
        const visado = oficinasVisadas.includes(oficina);
        return `${oficina}: ${visado ? "SI" : "NO"}`;
      })
      .join("<br>"); // Separar con saltos de línea
  };

  const handleSwitchChange = async (row, event) => {
    const oficinas = await getOficinasDeUsuario(usuario.id_usuario);
    const payload = {
      userOfficeIds: oficinas.data || [],
      requisitoOfficeNames: row.oficinasRelacionadas,
    };

    const newValue = !event.target.checked;
    try {
      const resultadoEvaluacionPorOficina =
        await evaluaPermisoPorOficinasDeUsuario(payload);

      // Ajusta la condición según la estructura real de la respuesta
      const tieneAcceso =
        resultadoEvaluacionPorOficina?.data?.hasAccess ??
        resultadoEvaluacionPorOficina.hasAccess;

      if (tieneAcceso) {
        // Cambia la opcionalidad del requisito
        setOpcionalidadDeRequisito(row.id_mov, newValue);
      } else {
        notification["error"]({
          message: "No podes modificar la opcionalidad de este requisito.",
        });
      }
    } catch (error) {
      console.log("Error al evaluar acceso por oficina", error);
      notification["error"]({
        message: "Error al evaluar acceso por oficina",
      });
    }
  };

  useEffect(() => {
    const fetchOficinas = async () => {
      try {
        const oficinas = await getOficinasDeUsuario(usuario.id_usuario);
        setOficinasUsuario(oficinas.data);  // Establecer las oficinas del usuario
      } catch (error) {
        console.error("Error fetching oficinas:", error);
      }
    };
  
    if (usuario?.id_usuario) {  // Comprobar si el usuario ya está cargado antes de hacer la solicitud
      fetchOficinas();
    }
  }, [usuario?.id_usuario])

  const tableContainerRef = useRef(null);

  const tablaMemo = useMemo(
    () => (
      <StyledTableContainer
        component={Paper}
        style={{ marginTop: "0px" }}
        ref={tableContainerRef}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div style={{ width: "55%" }}>
            <Typography
              variant="h6"
              align="right"
              style={{ fontWeight: "bold", color: COLORS.SECONDARY }}
            >
              Requisitos
            </Typography>
          </div>
          <div
            style={{
              marginRight: "20px",
            }}
          >
            <AddIcon
              style={{
                fontSize: 20,
                fontWeight: "bold",
                color:
                  accionAgregar && !disabled
                    ? COLORS.SECONDARY
                    : COLORS.DISABLED,
                cursor: accionAgregar && !disabled ? "pointer" : "not-allowed",
              }}
              onClick={accionAgregar && !disabled ? agregarRequisito : null}
            />
          </div>
        </div>
        <Table style={tableStyle}>
          <StyledTableHead>
            <TableRow>
              <TableCell style={cellHeaderStyle}>Fecha</TableCell>
              <TableCell style={cellHeaderStyle}>Requerimiento</TableCell>
              <TableCell style={cellHeaderStyle}>Formularios</TableCell>
              <TableCell style={cellHeaderStyle}>Oficina</TableCell>
              <TableCell style={cellHeaderStyle}>Opcional</TableCell>
              <TableCell style={cellHeaderStyle}>Estado</TableCell>
              <TableCell style={cellHeaderStyle}>Acciones</TableCell>
            </TableRow>
          </StyledTableHead>
          {data.length > 0 ? (
            <TableBody>
              {data.map((row, index) => (
                <StyledTableRow key={index} disabled={{ disabled }}>
                  <TableCell style={cellStyle}>
                    {moment(row.fecha).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {row.requisito_nombre}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {row.formularios > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <IconButton
                          onClick={() => obtenerFormularios(row)}
                          style={{
                            padding: 0, // Ajusta el padding si es necesario
                            cursor: "pointer",
                          }}
                        >
                          <InsertDriveFileOutlinedIcon
                            style={{
                              fontSize: 30,
                              color: COLORS.DARK_GREY,
                            }}
                          />
                        </IconButton>
                      </div>
                    )}
                  </TableCell>
                  <TableCell style={cellStyle}>{row.oficina_nombre}</TableCell>
                  <TableCell style={cellStyle}>
                    {accesoOpcionalRequisito ? (
                      <div>
                        <Switch
                          checked={row.opcional === 1}
                          onChange={(event) => {
                            handleSwitchChange(row, event);
                          }}
                          color="primary"
                        />
                      </div>
                    ) : (
                      <span>{row.opcional === 1 ? "SI" : "NO"}</span>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      backgroundColor: obtenerBackGroundColorPorEstado(
                        row.id_estado
                      ),
                    }}
                  >
                    <Tooltip
                      title={
                        <span
                          style={{ fontSize: "1.3rem" }}
                          dangerouslySetInnerHTML={{
                            __html: getTooltipPorEstado(
                              row.id_estado,
                              row.oficinasRelacionadas,
                              row.oficinasVisadas
                            ),
                          }}
                        />
                      }
                      arrow
                    >
                      <span className={obtenerColorPorEstado(row.id_estado)}>
                        {getEstadoNombre(row.id_estado)}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell style={cellStyle}>{obtenerAccion(row)}</TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={5}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "1rem" }}>
                    Sin datos
                  </span>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </StyledTableContainer>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      data,
      disabled,
      accionCompletar,
      accionAgregarPlantilla,
      accionVerificar,
      accionHistorial,
      accionEliminar,
      accionProcedimiento,
      accesoOpcionalRequisito,
    ]
  );

  return (
    <>
      {tablaMemo}
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={modalWidth}
      >
        {modalContent}
      </Modal>
    </>
  );
};
